import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function KineticHeadline({ lines, className = "", delay = 0, testId = "kinetic-headline" }) {
    return (
        <h1 data-testid={testId} className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
                    <motion.span
                        className="block will-change-transform"
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 1.2, ease: EASE, delay: delay + i * 0.15 }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </h1>
    );
}
